/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Description_Focus_LabelInputs */

const en_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe in each scene`)
};

const fr_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez chaque scène`)
};

const de_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreiben Sie in jeder Szene`)
};

const it_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrivi in ogni scena`)
};

const ru_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опишите каждую сцену.`)
};

const es_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe en cada escena`)
};

const zh_cn2_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述每个场景`)
};

const ja_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各シーンについて説明してください`)
};

const hi_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रत्येक दृश्य का वर्णन करें`)
};

const pt_pt2_ad_description_focus_label = /** @type {(inputs: Ad_Description_Focus_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreva cada cena.`)
};

/**
* | output |
* | --- |
* | "Describe in each scene" |
*
* @param {Ad_Description_Focus_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_description_focus_label = /** @type {((inputs?: Ad_Description_Focus_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Description_Focus_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_description_focus_label(inputs)
	if (locale === "de") return de_ad_description_focus_label(inputs)
	if (locale === "it") return it_ad_description_focus_label(inputs)
	if (locale === "ru") return ru_ad_description_focus_label(inputs)
	if (locale === "es") return es_ad_description_focus_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_description_focus_label(inputs)
	if (locale === "ja") return ja_ad_description_focus_label(inputs)
	if (locale === "hi") return hi_ad_description_focus_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_description_focus_label(inputs)
	return en_ad_description_focus_label(inputs)
});